import React from 'react';
import {
  Box,
  Flex,
  VStack,
  Heading,
  Text,
  HStack,
  Button,
  Image,
  useBreakpointValue,
} from '@chakra-ui/react';
import HeroImage from '../../assets/Landing/Illustration.svg';
import BlockImage from "../../assets/Landing/Blocks.svg";
import { useNavigate } from 'react-router-dom';

function HeroSection() {
  const isMobile = useBreakpointValue({ base: true, md: false });

  const navigate = useNavigate(); // Inicializa useNavigate

    const handleClick = () => {
        navigate('/Login'); // Función para navegar a /login
    };


  return (
    <Box
      bg="#FBFBFD"
      display="flex"
      flexDirection={isMobile ? 'column-reverse' : 'row'}
      alignItems="center"
      justifyContent="center"
      position="relative"
      height={isMobile ? "auto" : "679px"}  // Altura ajustada en móviles para evitar superposición
      width="full"
      marginX="auto"
    >
      <Flex
        align="center"
        justify="center"
        width={isMobile ? "full" : "720px"}
        height="full"
        order={isMobile ? 1 : null}
        marginLeft={isMobile ? "0%" : "5%"}  // Ajuste de margen a porcentaje
        paddingRight={isMobile ? "0" : "100px"}  // Agregar padding derecho para centrar el contenido si hay margen
      >
        <VStack
          spacing={4}
          align="flex-start"
          width="full"
          px={8}
        >
          <Heading
            as="h1"
            fontSize="64px"
            fontWeight="700"
            lineHeight="78px"
            color="#0D1216"
            textAlign="left"
          >
            Say <Text as="span" color="#90BCB5">Hello</Text> without <br />
            saying <Text as="span" color="#F4B3AE">“Hello”</Text>
          </Heading>
          <Text
            color="#0D1216"
            fontFamily="Quicksand"
            fontSize="20px"
            fontWeight="500"
            lineHeight="32px"
            textAlign="left"
            maxWidth="600px"
          >
            Dive into TEA's interactive adventures where kids with Autism Spectrum Disorder boost their emotion skills without saying a word! With cool challenges and fun gameplay, kids with ASD find new ways to express themselves, gaining confidence and making connections.
          </Text>
          <HStack justifyContent="flex-start" spacing={2}>
          <Button bg="#FCEBA2" color="#303030" href="#Download"><a href="#Download">How does it work?</a></Button>
            <Button  bg="#F0F0F2" color="#303030" onClick={handleClick} >Get a Demo</Button>
          </HStack>
        </VStack>
      </Flex>

      {/* Contenedor para las imágenes */}
      <Box
        position="relative"
        flex="1"
        height="full"
        width={isMobile ? "full" : "720px"}
        order={isMobile ? 2 : null}
      >
        <Image
          src={BlockImage}
          alt="Block Illustration"
          position="absolute"
          top="0"
          left="0"
          width="full"
          height="full"
          zIndex="-1"
        />
        <Image
          src={HeroImage}
          alt="Hero Illustration"
          objectFit="contain"
          maxWidth="full"
          maxHeight="full"
          margin="auto"
          position="relative"
          zIndex="1"
        />
      </Box>
    </Box>
  );
}

export default HeroSection;
